import { WorkingHoursDialogStore } from './working-hours-dialog.store';
import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../kit/action-buttons/action-buttons.component';
import { UserWorkplaceHoursObject } from '@libs/types/src/user/object-type/workplace/user-workplace-hours.object';
import { KeyValuePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DividerModule } from '@openng/optimus-ui/divider';
import { ShortTimePipe } from '../../../../modules/shared/pipes/short-time.pipe';

@Component({
    selector: 'app-working-hours-dialog',
    templateUrl: './working-hours-dialog.component.html',
    styleUrl: './working-hours-dialog.component.scss',
    providers: [WorkingHoursDialogStore],
    imports: [
        ActionButtonsComponent,
        KeyValuePipe,
        TranslatePipe,
        DividerModule,
        ShortTimePipe,
    ]
})
export class WorkingHoursDialogComponent extends BaseDialogComponent {

    public readonly store = inject(WorkingHoursDialogStore);

    protected parsedHours: Record<number, UserWorkplaceHoursObject[]> = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: [],
    };

    constructor() {
        super();
        this.dialogConfig?.data?.hours?.forEach((it: UserWorkplaceHoursObject) => {
            let day = it.day;
            if (day == 0) day = 7;
            this.parsedHours[day].push(it);
        });
    }

}
